// extracted by mini-css-extract-plugin
module.exports = {"hero":"termsOfServiceHero_hero__Wg6nz","hide":"termsOfServiceHero_hide__AImL3"};